<template>
  <v-form ref="form" class="">
    
    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
    />
    
    <v-row>

      <v-col cols="12" sm="12" md="12">
        <v-autocomplete
          v-model="entry.stockAdjustmentReasonId"
          v-bind="getObject('stockAdjustmentReasonId')"
          label="Motivo"
          :items="extraData.accountContext.allStockAdjustmentReasons"
          item-value="id"
          item-text="name"
          :disabled="readOnly"
          autocomplete="off"
        >
          <template v-slot:append-outer>
            <StockAdjustmentReasonNew
              :inlineAddButton="true"
              @entry-created="stockAdjustmentReasonCreated"
              modelNameSingular="Motivo"
            />
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="10" md="8" v-if="!isLoss">
        <v-autocomplete
          v-model="entry.storageId"
          v-bind="getObject('storageId')"
          label="Estoque"
          :items="extraData.accountContext.allStorages"
          item-value="id"
          item-text="name"
          :disabled="readOnly"
          autocomplete="off"
        >
          <template v-slot:append-outer>
            <StorageNew
              :inlineAddButton="true"
              @entry-created="storageCreated"
              modelNameSingular="Estoque"
            />
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="10" md="8" v-if="isLoss">
        <v-autocomplete
          v-model="entry.storageId"
          v-bind="getObject('storageId')"
          label="Estufa"
          :items="extraData.accountContext.allGreenhouses"
          item-value="id"
          item-text="name"
          :disabled="readOnly"
          autocomplete="off"
        >
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="6" md="4">
        <DateField
          :inputData.sync="entry.date"
          v-bind="getObject('date')"
          label="Data do Ajuste"
          :hasTodayButton="true"
          :hasTodayDate="true"
          :disabled="readOnly"
          autocomplete="off"
        />
      </v-col>

      <v-col cols="6" sm="8" md="8" v-if="isLoss">
       <v-switch 
          v-model="entry.removeFromStorage"
          inset 
          @change="onChange(entry.removeFromStorage)"
          :label="entry.removeFromStorage ? 'Remove da estufa' : 'Não remove da estufa'"
          :disabled="readOnly || (entry.id ? true : false)">
        </v-switch>
      </v-col>

      <v-col cols="12" class="" v-if="entry.storageId && isLoss && entry.removeFromStorage">
        <StorageAdjustmentItemsIndex
          :storageAdjustmentItems="entry.exitMovementItemsAttributes"
          :storageAdjustment="entry"
          :readOnly="readOnly"
          :isEdit="isEdit"
          :isLoss="isLoss"
          modelNameSingular="Perdas"
          modelNamePlural="Perdas"
        />
      </v-col>

      <v-col cols="12" class="" v-if="entry.storageId && isLoss && !entry.removeFromStorage">
        <StorageAdjustmentItemsIndex
          :storageAdjustmentItems="entry.dummyExitMovementItemsAttributes"
          :storageAdjustment="entry"
          :readOnly="readOnly"
          :isEdit="isEdit"
          :isLoss="isLoss"
          modelNameSingular="Perdas sem remover da estufa"
          modelNamePlural="Perdas sem remover da estufa"
        />
      </v-col>

      <v-col cols="12" class="" v-if="entry.storageId && !isLoss">
        <StorageAdjustmentItemsIndex
          :storageAdjustmentItems="entry.exitMovementItemsAttributes"
          :storageAdjustment="entry"
          :readOnly="readOnly"
          :isEdit="isEdit"
          :isLoss="isLoss"
          modelNameSingular="Item de ajuste"
          modelNamePlural="Itens de ajuste"
        />
      </v-col>

       <!-- <v-col cols="12" class="" v-if="entry.stockId && !entry.isStockEntryType">
        <StockAdjustmentConsumedItemsIndex
          :consumedItems="entry.consumedItemsAttributes"
          :stockAdjustment="entry"
          :readOnly="readOnly"
          :isEdit="isEdit"
        />
      </v-col> -->

      <v-col cols="12">
        <v-textarea
          v-model="entry.description"
          v-bind="getObject('description')"
          label="Observações"
          outlined
          autocomplete="off"
          :disabled="readOnly"
        ></v-textarea>
      </v-col>

    </v-row>
  </v-form>
</template>

<script>
import MaskedTextField from "@shared_components/masked_text_field.vue"
import DateField from "@shared_components/date_field.vue";
import StockAdjustmentReasonNew from "@models/stocks/stock_adjustments/stock_adjustment_reasons/new.vue"
import BaseUtil from "@shared_components/base_util.vue";
import StorageAdjustmentItemsIndex from "@models/storages/storage_adjustments/storage_adjustment_items/index.vue";
import StorageNew from "@models/storages/new.vue"

export default {
  data() {
    return {
      entryAttributes: {},
      pageLoading: false,
    };
  },
  props: {
    entry: Object,
    extraData: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    isLoss: {
      type: Boolean,
      default: false,
    },
    modelNameSingular: String,
  },
  components: {
    MaskedTextField: MaskedTextField,
    DateField: DateField,
    StorageAdjustmentItemsIndex: StorageAdjustmentItemsIndex,
    StorageNew: StorageNew,
    StockAdjustmentReasonNew: StockAdjustmentReasonNew,
    BaseUtil: BaseUtil,
  },
  created() {
    this.entryAttributes = this.setupEntryAttributes(this.entry);
  },
  mounted() {
  },
  methods: {
    onChange: function(change){
      if(!change && this.entry.dummyExitMovementItemsAttributes.length == 0){
        var self = this;
        this.entry.exitMovementItemsAttributes.forEach(function(item){
          item.dummyExitMovementItemLotsAttributes = item.exitMovementItemLotsAttributes;
          self.entry.dummyExitMovementItemsAttributes = [];
          self.entry.dummyExitMovementItemsAttributes.push(item);
        });
      }
      // else{
        // this.entry.exitMovementItemsAttributes = this.entry.dummyExitMovementItemsAttributes; 
      // }
    },
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },
    storageCreated: function(storage) {
      this.extraData.accountContext.allStorages.unshift(storage);
      this.entry.storageId = storage.id;
      this.entry.storage = storage;
    },
    stockAdjustmentReasonCreated: function(stockAdjustmentReason) {
      this.extraData.accountContext.allStockAdjustmentReasons.unshift(stockAdjustmentReason);
      this.entry.stockAdjustmentReasonId = stockAdjustmentReason.id;
      this.entry.stockAdjustmentReason = stockAdjustmentReason;
    },
  }
};
</script>

<style scoped></style>
